import request from '../utils/request';
import type { DatasetStats, SearchResponse } from '../types';

export const dataService = {
  // 导出数据集
  exportDataset: (datasetId: number): Promise<Blob> => {
    return request.get(`/data/datasets/${datasetId}/export`, {
      responseType: 'blob',
    });
  },

  // 导出所有数据
  exportAll: (): Promise<Blob> => {
    return request.get('/data/export-all', {
      responseType: 'blob',
    });
  },

  // 获取数据集统计
  getDatasetStats: (datasetId: number): Promise<DatasetStats> => {
    return request.get(`/data/datasets/${datasetId}/stats`);
  },

  // 搜索记录
  searchRecords: (phone: string, datasetId?: number): Promise<SearchResponse> => {
    const params: any = { phone };
    if (datasetId) {
      params.dataset_id = datasetId;
    }
    return request.get('/data/search', { params });
  },
};
